import React, { useState, useRef, useEffect } from "react";
import CalendarBase from "./CalendarBase";
import "../../styles/date-picker2.css";
import InputBase from "./InputBase";

interface DatePickerProps {
  tipo?: 'day' | 'month' | 'year';
  value?: Date | null;
  onChange?: (date: Date | null) => void;
  inputtable?: boolean;
  clearable?: boolean;
  inputFormat?: string;
  locale?: string;
  minDate?: Date;
  mode?: "single" | "range";
  size?: "sm" | "md" | "lg";
  withTime?: boolean;
}

const DatePicker: React.FC<DatePickerProps> = ({
  tipo,
  value,
  onChange,
  inputtable = true,
  clearable = false,
  inputFormat = "dd/MM/yyyy",
  locale = "pt-BR",
  minDate,
  size = "md",
  withTime = false,
}) => {
  const [open, setOpen] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const calendarRef = useRef<HTMLDivElement>(null);

  const handleInputFocus = () => {
    if (inputtable) {
      setOpen(true);
    }
  };

  const handleCalendarToggle = () => {
    setOpen((prev) => !prev);
  };

  const handleDateChange = (date: Date) => {
    setOpen(false);
    onChange?.(date);
  };

  const handleClear = () => {
    onChange?.(null);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (calendarRef.current && !calendarRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  return (
    <div className="date-picker-container">
      <div className="date-picker-input-wrapper">
      <InputBase
        tipo={tipo}
        ref={inputRef}
        value={value}
        onFocus={handleInputFocus}
        onChange={onChange}
        inputFormat={inputFormat}
        locale={locale}
        disabled={!inputtable}
        size={size}
        withTime={withTime}
        onCalendarToggle={handleCalendarToggle}
        onClear={clearable ? handleClear : undefined}
        inputtable={inputtable} 
        // onRequestCloseCalendar={() => setOpen(false)} 
      />

      </div>

      {open && (
        <div ref={calendarRef} className="date-picker-calendar-wrapper">
          <CalendarBase
            tipo={tipo}
            selected={value}
            onSelectDate={handleDateChange}
            minDate={minDate}
            withTime={withTime}
          />
        </div>
      )}
    </div>
  );
};

export default DatePicker;
